import axios from 'axios';


export default {
  // Collection
  createMachine (data) {
    return axios.post(`/machines`, data)
      .then(response => response.data);
  },
  getMachines ({ client_id }) {
    return axios.get(`/machines`, { params: { client_id } })
      .then(response => response.data);
  },

  // Item
  getMachine (id) {
    return axios.get(`/machines/${id}`)
      .then(response => response.data);
  },
  updateMachine (data) {
    return axios.put(`/machines/${data.machine_id}`, data)
      .then(response => response.data);
  },
  deleteMachine (id) {
    return axios.delete(`/machines/${id}`)
      .then();
  }
};
